const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-tile-article-block'] = {
        c: () => require('partner/modules/dlvry-tile-article-block/dlvry-tile-article-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-tile-article-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-tile-article-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dlvry-tile-article-block|dlvry-tile-article-block'] = {
                c: () => require('partner/modules/dlvry-tile-article-block/dlvry-tile-article-block.view.tsx'),
                cn: '__local__-__local__-dlvry-tile-article-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };